/**
 * Generates a lightweight browser fingerprint for fraud detection.
 * Combines multiple browser signals into a single hash.
 * Not meant to be a full FingerprintJS replacement — just enough
 * to catch the majority of self-referral abuse.
 */

function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash).toString(36);
}

function getCanvasFingerprint() {
    try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) return "";
        canvas.width = 200;
        canvas.height = 50;
        ctx.textBaseline = "top";
        ctx.font = "14px Arial";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText("fingerprint", 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("fingerprint", 4, 17);
        return canvas.toDataURL();
    } catch {
        return "";
    }
}

export function generateDeviceFingerprint() {
    const signals = [
        navigator.userAgent,
        navigator.language,
        screen.width + "x" + screen.height,
        screen.colorDepth,
        new Date().getTimezoneOffset(),
        navigator.hardwareConcurrency || "",
        navigator.maxTouchPoints || 0,
        navigator.platform || "",
        getCanvasFingerprint(),
    ];

    return "fp_" + hashCode(signals.join("|"));
}
